import {
  SET_OPENED_MODAL,
  CHANGE_HEADER_TYPE,
  CHANGE_CONDITION_SHOWN,
  SET_OPENED_MODAL_START,
} from "./consts";

const initialState = {
  openedModal: "",
  openedModalStart: "",
  openedPrivacyOrTerms: "", //privacy, terms
  headerType: "default",
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OPENED_MODAL_START:
      return { ...state, openedModalStart: action.payload };
    case SET_OPENED_MODAL:
      return { ...state, openedModal: action.payload };
    case CHANGE_HEADER_TYPE:
      return { ...state, headerType: action.payload };
    case CHANGE_CONDITION_SHOWN:
      return { ...state, openedPrivacyOrTerms: action.payload };
    default:
      return state;
  }
};
